import resource from './../../../services/purchase/payment';
import paymentList from './paymentList';
import paymentBanks from './paymentBanks';

export default {
    namespaced: true,
    modules: {
        paymentList,
        paymentBanks
    },
    actions: {
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                resource.findByID(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        create(context, payload) {
            return new Promise((resolve, reject) => {
                resource.create(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                resource.update(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        remove(context, payload){
            return new Promise((resolve, reject) => {
                resource.remove(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        post(context, payload){
            return new Promise((resolve, reject) => {
                resource.post(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        print(context, payload) {
            return resource.print(payload);
        }
    }
}